import { config } from "../configs";

export const removeNullAndUndefinedFromObject = (object) =>
  Object.entries(object).reduce(
    (acc, [key, val]) =>
      val === undefined || val === null ? acc : ((acc[key] = val), acc),
    {}
  );

export const getAvatarInitials = (value) => {
  return `${config.avatar_dicebear_url}/${value}.svg?chars=2`;
};

export const flattenTree = (node) => {
  const flattened = [];
  function traverse(node) {
    flattened.push(node);
    if (node.sub_orgs.length > 0) {
      node.sub_orgs.forEach((child) => {
        traverse(child);
      });
    }
  }
  traverse(node);
  return flattened;
};

export const flattenPlacesTree = (places) => {
  const flattened = [];
  function traverse(node) {
    flattened.push(node);
    if (node?.child_places?.length > 0) {
      node?.child_places?.forEach((child) => {
        traverse(child);
      });
    }
  }
  places.forEach((place) => {
    traverse(place);
  });
  return flattened;
};

export const getPlacesBreadcrumb = (places, placeId) => {
  let breadcrumb = [];
  let place = places.find((place) => place.id === placeId);
  if (place) {
    breadcrumb.push(place);
    while (place.parent_place) {
      place = places.find((place) => place.id === place.parent_place);
      breadcrumb.push(place);
    }
  }
  return breadcrumb.reverse();
};

export const getPlacesBreadcrumbBySystemId = (places, placeId) => {
  let breadcrumb = [];
  let place = places.find((place) => place.system_id === placeId);
  if (place) {
    breadcrumb.push(place);
    while (place?.parent !== null && place) {
      // eslint-disable-next-line no-loop-func
      place = places.find((newPlace) => newPlace?.system_id === place?.parent);
      breadcrumb.push(place);
    }
  }
  return breadcrumb.reverse();
};

export const validateImageType = (file) => {
  const pattern = /image\/[jpe?g|png|webp|svg+xml]/gm
  return file && pattern.test(file?.type);
}
